export default __webpack_public_path__ + "static/11_33-1--45ef93011eac009946b8dcfc5346fb20.png";